import React from 'react';
import { useNavigate } from 'react-router-dom';
import telegramService from '../services/telegram';

// Слайд шире экрана мешает свайпу, а жёсткие 380px на маленьком телефоне
// занимают весь первый экран. Высота — доля вьюпорта с потолком.
const SLIDE_WIDTH = 280;
const SLIDE_HEIGHT = 'min(380px, 46vh)';

const HeroCarousel = ({ slides, loading }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <section className="py-4">
        <div className="flex gap-3 px-4 overflow-hidden">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex-shrink-0 bg-theme-card-secondary rounded-lg animate-pulse"
              style={{ width: SLIDE_WIDTH, height: SLIDE_HEIGHT }}
            />
          ))}
        </div>
      </section>
    );
  }

  if (!slides || slides.length === 0) {
    return null;
  }

  const handleCardClick = (slide) => {
    telegramService.hapticFeedback('light');
    if (slide.link) {
      // Если ссылка внешняя - открываем в браузере
      if (slide.link.startsWith('http://') || slide.link.startsWith('https://')) {
        telegramService.openLink(slide.link);
      } else {
        // Внутренняя навигация
        navigate(slide.link);
      }
    }
  };

  const getImageUrl = (slide) => {
    if (!slide.image) {
      return 'https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=800&q=80';
    }

    const imageUrl = slide.image.url?.startsWith('http')
      ? slide.image.url
      : slide.image.url;

    return imageUrl;
  };

  return (
    <section className="pt-4">
      {/* Инерция вместо жёсткого снапа: `snap-mandatory` обязывал браузер
          доводить прокрутку до ближайшей карточки, поэтому сильный свайп
          гасился и лента вставала на следующем слайде. `proximity`
          подтягивает только когда карточка и так почти на месте.
          `scroll-behavior: smooth` убран отдельно: он анимировал каждое
          дотягивание и съедал ощущение отклика на силу свайпа */}
      <div
        className="flex gap-3 px-4 overflow-x-auto snap-x snap-proximity scrollbar-hide"
        style={{
          scrollPadding: '16px',
        }}
      >
        {slides.map((slide) => (
          <button
            key={slide.id}
            onClick={() => handleCardClick(slide)}
            className="flex-shrink-0 rounded-lg overflow-hidden relative snap-start transition-transform duration-fast active:scale-98"
            style={{ width: SLIDE_WIDTH, height: SLIDE_HEIGHT }}
          >
            {/* Image */}
            <img
              src={getImageUrl(slide)}
              alt={slide.title}
              className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Gradient Overlay */}
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.7) 100%)',
              }}
            />

            {/* Text Content */}
            <div className="absolute bottom-0 left-0 right-0 p-5 text-left">
              <p className="text-caption text-white mb-2 opacity-90">
                {slide.categoryLabel || 'Место'}
              </p>
              {/* Тот же кегль, что у заголовков секций. Слайд и так самое
                  крупное на экране за счёт фото 280×380 — спорить с ними
                  ещё и кеглем не нужно, а на длинном названии крупный
                  заголовок забивает картинку */}
              <h3 className="text-h2 text-white">
                {slide.title}
              </h3>
            </div>
          </button>
        ))}
      </div>

      {/* Индикатор страниц убран: он жил в состоянии компонента, а позиция
          скролла восстанавливается из кеша страницы — при возврате назад
          точки показывали середину, хотя карусель стояла в начале.
          Что слайдов несколько, и так видно по обрезанному краю соседнего */}
    </section>
  );
};

export default HeroCarousel;
